import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('details-block', {
    attrs: {
      "title": _vm.t('商品信息')
    }
  }, [_c('details-field', {
    attrs: {
      "label": _vm.t('商品编码'),
      "content": _vm._f("filterEmpty")(_vm.data.product_sku)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('商品名称'),
      "content": _vm._f("filterEmpty")(_vm.data.product_name_cn)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('仓库')
    }
  }, [_c('my-operation', [_vm._v(_vm._s(_vm.data.warehouse_code) + "[" + _vm._s(_vm.data.warehouse_name) + "]")])], 1), _c('details-field', {
    attrs: {
      "label": _vm.t('国家/地区'),
      "content": _vm._f("filterEmpty")(_vm.data.country_name)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('创建时间'),
      "content": _vm._f("filterEmpty")(_vm.data.create_time)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('冻结状态'),
      "content": _vm._f("filterEmpty")(_vm.data.freeze_status_text)
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };